'use strict';

const device = require('./device');
const page = require('./page');
const source = require('./source');
const visitor = require('./visitor');

const isNotEmptyString = (value) => {
    if (typeof value === 'string' && value.length > 0) {
        return true;
    }
    return false;
};

const hasValidAttribute = (element, attribute) => {
    if (element.hasAttribute(attribute) === true
        && isNotEmptyString(element.getAttribute(attribute))) {
        return true;
    }
    return false;
};

const applyConfiguration = (dimensions) => {
    const body = document.querySelector('body');

    if (!body) {
        return dimensions;
    }

    if (hasValidAttribute(body, 'data-bridge-tracking-client-id')) {
        dimensions.clientId = body.getAttribute('data-bridge-tracking-client-id');
    }

    if (hasValidAttribute(body, 'data-bridge-tracking-front-office-id')) {
        dimensions.frontOfficeId = body.getAttribute('data-bridge-tracking-front-office-id');
    }

    if (hasValidAttribute(body, 'data-bridge-tracking-location-id')) {
        dimensions.locationId = body.getAttribute('data-bridge-tracking-location-id');
    }

    if (hasValidAttribute(body, 'data-bridge-tracking-locale')) {
        dimensions.locale = body.getAttribute('data-bridge-tracking-locale');
    }

    return dimensions;
};

const applyOptions = (dimensions, options) => {
    if (isNotEmptyString(options.locationId)) {
        dimensions.locationId = options.locationId;
    }

    if (isNotEmptyString(options.formId)) {
        dimensions.formId = options.formId;
    }

    return dimensions;
};

const buildDimensions = (options = {}) => {
    let dimensions = {
        clientId: null,
        frontOfficeId: null,
        locationId: null,
        formId: null,
        locale: null,
        device: null, // Possible values: phone, tablet, desktop
        origin: null, // Possible values: utm, organic, referral, typein
        referer: null, // referer when first arrived on page
        page: null, // current page
        utmSource: null,
        utmMedium: null,
        utmCampaign: null,
        utmContent: null,
        utmTerm: null,
        sessionId: null,
        visitorId: null,
        value: 1
    };

    dimensions.device = device();
    dimensions.origin = source.getOrigin();
    dimensions.referer = source.getReferer();
    dimensions = source.applyUtmParameters(dimensions);

    dimensions.page = page.getPage(window.location.pathname);

    dimensions.sessionId = visitor.getOrSetSessionId();
    dimensions.visitorId = visitor.getOrSetVisitorId();

    dimensions = applyConfiguration(dimensions);
    dimensions = applyOptions(dimensions, options);

    return dimensions;
};

module.exports = buildDimensions;
